import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { i18n } from '../../i18n/translate.js';
import { Callout } from '../../core/components/Callout/component.js';
import Button from '../../core/components/Button/component.js';
import { Modal } from '../../core/components/Modal/component.js';
import { Layout } from '../../core/components/Layout/component.js';
var GenericModal = function GenericModal(props) {
  var canClose = props.canClose,
    children = props.children,
    footerCloseButton = props.footerCloseButton,
    id = props.id,
    isCentered = props.isCentered,
    message = props.message,
    messageType = props.messageType,
    onClose = props.onClose,
    saveButtonConfig = props.saveButtonConfig,
    _props$show = props.show,
    show = _props$show === void 0 ? true : _props$show,
    showAlert = props.showAlert,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    stickyFooter = props.stickyFooter,
    title = props.title;
  var modalFooter = /*#__PURE__*/React.createElement(React.Fragment, null, footerCloseButton && /*#__PURE__*/React.createElement(Button, _extends({
    id: footerCloseButton.id || 'generic-modal-cancel-button',
    onClick: onClose,
    variant: footerCloseButton.variant || 'secondary',
    "data-action": footerCloseButton.dataAction || 'cancel-button'
  }, footerCloseButton.attributes), footerCloseButton.label || i18n.t('Cancel')), saveButtonConfig && /*#__PURE__*/React.createElement(Button, _extends({
    isDisabled: saveButtonConfig.disabled,
    id: saveButtonConfig.id || 'generic-modal-save-button',
    onClick: saveButtonConfig.onClick,
    variant: saveButtonConfig.variant,
    "data-action": saveButtonConfig.dataAction || 'save-button'
  }, saveButtonConfig.attributes), saveButtonConfig.label || i18n.t('Save')));
  return /*#__PURE__*/React.createElement(Modal, {
    footer: modalFooter,
    header: title,
    id: id,
    isCentered: isCentered || stickyFooter,
    isOpen: show,
    modalType: "modal",
    onClose: onClose,
    showCloseButton: canClose,
    size: size
  }, showAlert && /*#__PURE__*/React.createElement(Layout, {
    mb: 4
  }, /*#__PURE__*/React.createElement(Callout, {
    description: message,
    showIcon: false,
    title: "",
    variant: messageType
  })), children);
};
GenericModal.displayName = "GenericModal";
export { GenericModal };